import { ICustomField } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryConfig } from "@ws-react-query";
import { customFieldsService } from "../../../services/customFields";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_CUSTOM_FIELD } from "../keys";

export const useQueryCustomField = (
  id: string,
  config?: WSQueryConfig<ICustomField, WSServiceError>
) => {
  return useWSQuery<ICustomField, WSServiceError>(
    [QUERY_CUSTOM_FIELD, id],
    async () => await customFieldsService.customField.get(id),
    {
      refetchOnMount: false,
      ...config
    }
  );
};
